import styled from "styled-components";
import { COLORS, responsive } from "../../../../../styles/constants.style";

export const BulkInsertAddActivityWrapper = styled.div`
  padding: 24px 0px 24px 16px;

  .MuiGrid2-root {
    padding-right: 18px;
    margin-top: 40px;
    &:nth-child(-n + 3) {
      margin-top: 0px;
    }
    ${responsive.TABLET_LANDSCAPE`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 0px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
      &:nth-child(-n + 2) {
      margin-top: 0px;
    }
    `}
    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 0px;
      }
      &:nth-child(n+2) {
        margin-top: 24px;
        }
    `}
  }

  .MuiGrid2-container {
    padding-right: 0px;
  }
`;

export const BulkActivityDetailsWrapper = styled.div`
  .title-container {
    display: flex;
    align-items: center;
    padding-left: 16px;
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
  }
  .form-header {
    padding-left: 16px;
  }

  .activity-details-accordion {
    margin-top: 32px;
    .MuiCollapse-wrapper {
      margin-top: 8px;
    }
    .MuiAccordionSummary-expandIconWrapper {
      margin-left: 16px;
    }

    .selected-count {
      color: ${COLORS.cirrus_white};
      background-color: ${COLORS.cirrus_black7};
      padding: 2px 9px 4px 9px;
      border-radius: 7px;
      margin-left: 8px;
    }

    .error-info-icon {
      cursor: pointer;
    }
  }
  .activity-details-accordion:last-child {
    margin-bottom: 32px;
  }
  
  .name-field {
    margin: 24px 16px;
    width: 320px;
    ${responsive.MOBILE`
      margin: 0;
      padding: 16px 16px 16px 8px;
      width: 100%;
    `}
  }
`;
